import { useAtom } from "jotai";

import { $workflowSchedulerEffect } from "../../internal/workflows";

/**
 * Hook that mounts the workflows scheduler effect.
 *
 * Call this once at app startup to start cron-based workflow scheduling.
 * Only activates when the Workflows feature flag is enabled and running on desktop.
 */
export const useWorkflowsLoader = () => {
	useAtom($workflowSchedulerEffect);
};
